var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_459_2898)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 27L19.3186 14.6244M27 18.9375C24.8012 21.4287 21.5841 23 18 23C14.4159 23 11.1988 21.4287 9 18.9375M9 27L16.6814 14.6244M18 10C16.6193 10 15.5 11.1193 15.5 12.5C15.5 13.3967 15.9721 14.1832 16.6814 14.6244M18 10C19.3807 10 20.5 11.1193 20.5 12.5C20.5 13.3967 20.0279 14.1832 19.3186 14.6244M18 10V9M19.3186 14.6244C18.9358 14.8625 18.484 15 18 15C17.516 15 17.0642 14.8625 16.6814 14.6244",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_459_2898",
    x1: 0,
    y1: 0,
    x2: 36.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionSettingsIcon);
export default __webpack_public_path__ + "static/media/collectionSettingsIcon.86a17401af9cc6e99a700efb38cbaeb6.svg";
export { ForwardRef as ReactComponent };